import { render, staticRenderFns } from "./IngredientChapter.vue?vue&type=template&id=ee3e75e4&scoped=true"
import script from "./IngredientChapter.vue?vue&type=script&lang=js"
export * from "./IngredientChapter.vue?vue&type=script&lang=js"
import style0 from "./IngredientChapter.vue?vue&type=style&index=0&id=ee3e75e4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3e75e4",
  null
  
)

export default component.exports